import { getAuth } from "firebase/auth";

function getApiBaseUrl() {
  const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  const fallback =
    "https://us-central1-houari-boumedienne-schoo-4d4c2.cloudfunctions.net";
  const configured = process.env.REACT_APP_API_BASE_URL || "";
  return String(isLocalhost ? configured || fallback : configured).replace(/\/+$/, "");
}

async function callKnowledgeBaseApi(path, body) {
  const user = getAuth().currentUser;
  if (!user) {
    throw new Error("Please sign in again to continue.");
  }

  const idToken = await user.getIdToken();
  const endpoint = `${getApiBaseUrl()}/api/knowledge-base/${path}`;

  const response = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(body),
  });

  const contentType = response.headers.get("content-type") || "";
  const payload = contentType.includes("application/json")
    ? await response.json()
    : { ok: false, error: await response.text() };

  if (!response.ok || !payload.ok) {
    throw new Error(payload.error || "Something went wrong.");
  }

  return payload;
}

export function deleteKnowledgeBaseDocument({ teacherDocId, docId }) {
  return callKnowledgeBaseApi("delete-document", { teacherDocId, docId });
}
